import React, { useState } from "react";

const WebBT = () => {
  const [device, setDevice] = useState(null);
  const [error, setError] = useState("");
  const [isConnected, setIsConnected] = useState(false);

  const requestDevice = async () => {
    setError("");
    try {
      // Request a Bluetooth device with any service
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true, // or specify filters with services
        optionalServices: ["battery_service"] // optional
      });

      console.log("Device selected:", device);
      setDevice(device);

      // Connect to the GATT server
      const server = await device.gatt.connect();
      console.log("Connected to GATT server:", server);
      setIsConnected(true);

      // Example: get battery level if available
      if (device.gatt.connected) {
        const service = await server.getPrimaryService("battery_service");
        const characteristic = await service.getCharacteristic("battery_level");
        const value = await characteristic.readValue();
        const batteryLevel = value.getUint8(0);
        console.log("Battery Level:", batteryLevel, "%");
      }
    } catch (err) {
      console.error("Bluetooth error:", err);
      setError(err.message);
    }
  };

  const disconnectDevice = async () => {
    setError("");
    try {
      if (device && device.gatt.connected) {
        device.gatt.disconnect();
        console.log("Disconnected from device");
        setIsConnected(false);
        setDevice(null);
      }
    } catch (err) {
      console.error("Disconnect error:", err);
      setError(err.message);
    }
  };

  const unpairDevice = async () => {
    setError("");
    try {
      // First disconnect if connected
      if (device && device.gatt.connected) {
        device.gatt.disconnect();
        console.log("Disconnected from device");
      }
      
      // Clear device from app state (unpair/forget)
      setDevice(null);
      setIsConnected(false);
      console.log("Device unpaired/forgotten from app");
      
      // Note: Web Bluetooth API doesn't provide direct unpair method
      // The browser may still remember the device in its pairing list
    } catch (err) {
      console.error("Unpair error:", err);
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>Bluetooth Test (Bluefy)</h1>
      <div style={{ marginBottom: 20 }}>
        <button 
          onClick={requestDevice} 
          disabled={isConnected}
          style={{ 
            marginRight: 10, 
            padding: '10px 20px',
            backgroundColor: isConnected ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: isConnected ? 'not-allowed' : 'pointer'
          }}
        >
          Connect to Bluetooth Device
        </button>
        <button 
          onClick={disconnectDevice} 
          disabled={!isConnected}
          style={{ 
            marginRight: 10,
            padding: '10px 20px',
            backgroundColor: !isConnected ? '#ccc' : '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: !isConnected ? 'not-allowed' : 'pointer'
          }}
        >
          Disconnect Device
        </button>
        <button 
          onClick={unpairDevice} 
          disabled={!device}
          style={{ 
            padding: '10px 20px',
            backgroundColor: !device ? '#ccc' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: !device ? 'not-allowed' : 'pointer'
          }}
        >
          Unpair/Forget Device
        </button>
      </div>
      {device && (
        <div style={{ marginBottom: 20 }}>
          <p><strong>Connected Device:</strong> {device.name || "Unnamed Device"}</p>
          <p><strong>Connection Status:</strong> {isConnected ? "Connected" : "Disconnected"}</p>
        </div>
      )}
      
      <div style={{ 
        marginTop: 20, 
        padding: 15, 
        backgroundColor: '#f8f9fa', 
        border: '1px solid #dee2e6', 
        borderRadius: '5px',
        fontSize: '14px'
      }}>
        <p><strong>Button Functions:</strong></p>
        <p><strong>Disconnect:</strong> Temporarily disconnects from the device (can reconnect easily)</p>
        <p><strong>Unpair/Forget:</strong> Removes device from app memory (requires full re-pairing)</p>
        <p><em>Note: Browser may still remember the device in its pairing list</em></p>
      </div>
      
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
    </div>
  );
};

export default WebBT;
